interface HealthBarProps {
  ready: number;
  pending?: number;
  failed?: number;
  total: number;
  width?: number;
}

/**
 * Compact stacked bar: ready (ok) / pending (warn) / failed (danger).
 * Empty (total === 0) shows a faint dashed track.
 */
export function HealthBar({
  ready,
  pending = 0,
  failed = 0,
  total,
  width = 80,
}: HealthBarProps) {
  if (total <= 0) {
    return (
      <span
        className="healthbar healthbar--empty"
        style={{ width }}
        title="no replicas"
      />
    );
  }
  const r = (ready / total) * 100;
  const p = (pending / total) * 100;
  const f = (failed / total) * 100;
  return (
    <span
      className="healthbar"
      style={{ width }}
      title={`ready ${ready} / pending ${pending} / failed ${failed} of ${total}`}
    >
      {ready > 0 && (
        <span className="healthbar__seg healthbar__seg--ok" style={{ width: `${r}%` }} />
      )}
      {pending > 0 && (
        <span className="healthbar__seg healthbar__seg--warn" style={{ width: `${p}%` }} />
      )}
      {failed > 0 && (
        <span
          className="healthbar__seg healthbar__seg--danger"
          style={{ width: `${f}%` }}
        />
      )}
    </span>
  );
}
